import React, { useState, useEffect } from 'react';
import ChartCard from "../shared/ChartCard";
import PageTitle from "../shared/PageTitle";
import {
  CircularProgress,Table, TableBody, TableCell, TableContainer, TableRow, TableHead,Paper,Button
} from '@mui/material';
import axios from 'axios';


const Penolakan = () => {
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1); // Current page
    const itemsPerPage = 10; 
    const beUrl = process.env.REACT_APP_BE

    useEffect(() => {
        fetchData(); 
    }, [beUrl,currentPage]);

    const fetchData = async () => {
        setIsLoading(true);
        try {
            const offset = (currentPage - 1) * itemsPerPage;
            const response = await axios.get(`${beUrl}/api/v1/pgsql/Penolakan`, {
                params: {
                    awal: offset,
                    akhir: itemsPerPage
                },
                headers: {
                  Authorization: `Bearer ${localStorage.getItem('token')}`,
                }
            });
            setData(response.data.data || []); 
        } catch (error) {
            console.error('Error fetching data:', error);
        }
        setIsLoading(false);
    };

    const handleNextPage = () => {
        setIsLoading(true); 
        setCurrentPage(currentPage + 1);
      };
      
      const handlePreviousPage = () => {
        setIsLoading(true); 
        setCurrentPage(currentPage - 1);
      };
    
  
  return (
    <div className="grid gap-6 mt-5 mb-6 grid-cols-1 xl:grid-cols-1">
    <PageTitle>Penolakan Peminjaman Buku Tanah/Warkah</PageTitle>
    <div className="grid gap-6 mt-5 mb-6 grid-cols-1 xl:grid-cols-1">
    <ChartCard>
       {isLoading ? ( // Tampilkan CircularProgress jika isLoading true
        <CircularProgress style={{ margin: '50px auto', display: 'block' }} />
      ) : data?.length > 0 ? ( // Cek apakah ada data
        <React.Fragment>
        <TableContainer component={Paper} style={{ marginTop: '20px'  }}>
        <Table>
          <TableHead>
              <TableRow>
              <TableCell align='center' style={{ backgroundColor: '#0288d1', color: 'white', border: '1px solid #ddd', padding: '8px' }}>No</TableCell>
              <TableCell align='center' style={{ backgroundColor: '#0288d1', color: 'white', border: '1px solid #ddd', padding: '8px' }}>Nomor Hak/Warkah</TableCell>  
              <TableCell align='center' style={{ backgroundColor: '#0288d1', color: 'white', border: '1px solid #ddd', padding: '8px' }}>Tahun</TableCell> 
              <TableCell align='center' style={{ backgroundColor: '#0288d1', color: 'white', border: '1px solid #ddd', padding: '8px' }}>ID Pinjam</TableCell> 
              <TableCell align='center' style={{ backgroundColor: '#0288d1', color: 'white', border: '1px solid #ddd', padding: '8px' }}>Jenis Peminjaman</TableCell>  
              <TableCell align='center' style={{ backgroundColor: '#0288d1', color: 'white', border: '1px solid #ddd', padding: '8px' }}>Tanggal Input</TableCell> 
              <TableCell align='center' style={{ backgroundColor: '#0288d1', color: 'white', border: '1px solid #ddd', padding: '8px' }}>Tanggal Pinjam</TableCell> 
              <TableCell align='center' style={{ backgroundColor: '#0288d1', color: 'white', border: '1px solid #ddd', padding: '8px' }}>Tanggal Ditolak</TableCell> 
              <TableCell align='center' style={{ backgroundColor: '#0288d1', color: 'white', border: '1px solid #ddd', padding: '8px' }}>Status</TableCell>
              <TableCell align='center' style={{ backgroundColor: '#0288d1', color: 'white', border: '1px solid #ddd', padding: '8px' }}>Keterangan</TableCell>  
                {/* Tambahkan lebih banyak TableCell sesuai kebutuhan */}
              </TableRow>
            </TableHead>
            <TableBody>
            {data.map((item, index) => {
                   const rowNumber = (currentPage - 1) * itemsPerPage + index + 1; 
                   let status;
                   let statusColor;
                   if (item.status === null) {
                     status = 'Waiting';
                     statusColor = '#ed9b40';
                 } else if (item.status === '1' && item.status_pengembalian === '2') {
                     status = 'Selesai';
                     statusColor = '#61c9a8';
                 } else if (item.status === '1' && item.status_pengembalian === '1' && item.status_tu ==='1') {
                   status = 'Pengembalian';
                   statusColor = '#0288d1';
                 }  else if (item.status === '1' && item.status_pengembalian === null && item.status_tu === null) {
                     status = 'Dipinjam';
                     statusColor = '#d64550';
                 } else if (item.status === 'tolak' && item.status_pengembalian === '2' && item.status_tu === '2') {
                   status = 'Ditolak';
                   statusColor = '#d64550';
               }
               return (
                <TableRow key={index}>
                <TableCell align="center">{rowNumber}</TableCell>
                        <TableCell align="center" style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center', }}>{item.nomorhak !== "NULL" ? item.nomorhak : item.nomordi208}</TableCell>
                        <TableCell align="center" style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center', }}>{item.tahun !== "null" ? item.tahun : '-'}</TableCell>
                        <TableCell align="center" style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center', }}>{item.paket}</TableCell>
                        <TableCell align="center" style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center', }}>{item.jenis}</TableCell>
                        <TableCell align="center" style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center', }}>{item.tglinput}</TableCell>
                        <TableCell align="center" style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center', }}>{item.tglpinjam ? item.tglpinjam : '-' }</TableCell>
                        <TableCell align="center" style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center', }}>{item.tglkembali ? item.tglkembali : '-'}</TableCell>
                        <TableCell align="center" style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center', color: statusColor }}>{status}</TableCell>
                        <TableCell align="center" style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center', }}>{item.keterangan ?  item.keterangan : '-'}</TableCell>
                </TableRow>
            );
            })}
          </TableBody>
          </Table>
      </TableContainer>     
            <div style={{ display: 'flex', justifyContent: 'right', marginTop: '20px' }}>
            <Button onClick={handlePreviousPage} disabled={currentPage === 1} variant="contained" color="warning" size="small" style={{ marginRight: '10px' }}>Previous</Button>
            <Button onClick={handleNextPage} disabled={data?.length < itemsPerPage} variant="contained" size="small">Next</Button>
          </div>
</React.Fragment>
     ) : (
      <ChartCard>
        <h6 className="text-center text-sm xl:text-lg font-medium">
          Belum Ada Peminjaman DItolak !
        </h6>
      </ChartCard>
    )}
      </ChartCard>
      </div>
</div>

  );
}
export default Penolakan;